import { useQuery } from '@tanstack/react-query';

import { getProjectCategories } from '@/features/projects/categories/api/get-project-categories';

export function useCategoriesQuery() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      const categories = await getProjectCategories();
      return { categories };
    },
  });
}
